<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-items-center">
    <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-w-1/2 wf-text-xs wf-tracking-wide">Width</span>
    <input
      v-model="width"
      type="text"
      class="wf-w-1/2 wf-text-right focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
    />
  </li>
</template>

<script>
  import _ from 'lodash'
  import { WidthStyle } from '../styles/WidthStyles'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      width: {
        get() {
          let width = this.elementStyles(this.styles)[this.device].find(deviceStyle => deviceStyle.property == WidthStyle.property)
          if (! width) {
            width = {...WidthStyle, value: '400px', touched: false}
            this.addToArray(this.module, [width], this.styles, this.device, {}, true, this.parentModule)
          }
          return width.value
        },
        set: _.debounce(function (value) {
          let width = {...WidthStyle, value: value, touched: false}
          this.addToArray(this.module, [width], this.styles, this.device, {}, true, this.parentModule)
        }, 500)
      },
    }
  })
</script>
